<header class="site-header">
  <div class="container nav-row">
    
    <!-- Logo -->
    <a class="brand" routerLink="/home" (click)="closeMenu()">
      <img class="brand-mark" src="assets/aura-logo.jpeg" alt="AURA GROUPS">
      <span class="brand-text">AURA GROUPS</span>
    </a>

    <!-- Hamburger Toggle Button -->
    <button class="menu-toggle" type="button" (click)="toggleMenu()">
      <i class="fa-solid" [ngClass]="isOpen ? 'fa-xmark' : 'fa-bars-staggered'"></i>
    </button>

    <!-- Navigation Menu Wrapper -->
    <nav class="nav-links" [class.open]="isOpen" [class.disable-hover]="forceCloseMega">
      
      <!-- Drawer Header Layout (Visible on Mobile inside drawer only) -->
      <div class="drawer-header">
        <div class="brand">
          <img class="brand-mark" src="assets/aura-logo.jpeg" alt="AURA GROUPS">
          <span class="brand-text">AURA GROUPS</span>
        </div>
        <button class="menu-close" type="button" (click)="closeMenu()">&times;</button>
      </div>

      <!-- Navigation Ul Container -->
      <ul class="nav-list">     
        <li>
          <a class="nav-item" [routerLink]="['/home']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">Home</a>
        </li>
        <!-- Services Accordion / Mega Menu Trigger Link -->
        <li class="dropdown-li" [class.expanded]="isServicesExpanded">
          <a class="nav-item dropdown-toggle" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" (click)="toggleServices($event)">
            Services <span class="chevron"></span>
          </a>
          
          <!-- Services Mega Content Inner Layer -->
          <div class="mega-menu" [class.forced-closed]="forceCloseMega">
            <div class="mega-menu-actions mobile-only">
              <a routerLink="/services" class="view-all-btn" (click)="onServiceLinkClick()">View all services</a>
            </div>
            <div class="mega-menu-inner">
              
              <!-- Column 1: Offerings -->
              <div class="mega-col">
                <h4>PROFESSIONAL SERVICE OFFERINGS</h4>
                <a routerLink="/services/core-construction" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-trowel-bricks service-icon"></i>
                  <div class="service-info">
                    <h5>Construction Service</h5>
                    </div>
                </a>
                <a routerLink="/services/interior-exterior" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-building-wheat service-icon"></i>
                  <div class="service-info">
                    <h5>Interior & Exterior Service</h5>
                    </div>
                </a>
                <a routerLink="/services/real-estate" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-handshake service-icon"></i>
                  <div class="service-info">
                    <h5>Real Estate Service</h5>
                  </div>
                </a>
                <a routerLink="/services/3d-design" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-vr-cardboard service-icon"></i>
                  <div class="service-info">
                    <h5>3D Visualization Service</h5>
                  </div>
                </a>
                <a routerLink="/services/dtcp-approvals" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-file service-icon"></i>
                  <div class="service-info">
                    <h5>DTCP Service</h5>
                  </div>
                </a>
                <a routerLink="/services/floor-plans" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-building service-icon"></i>
                  <div class="service-info">
                    <h5>Floor Plans Service</h5>
                  </div>
                </a>
              </div>

              <!-- Column 2: Transactions -->
               <div class="mega-col">
                <h4>SOFTWARE SERVICES</h4>
                <a routerLink="/services/web-development" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-code service-icon"></i>
                  <div class="service-info">
                    <h5>Website Development</h5>
                  </div>
                </a>
                <a routerLink="/services/app-development" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-brands fa-google-play service-icon"></i>
                  <div class="service-info">
                    <h5>App Development</h5>
                  </div>
                </a>
                <a routerLink="/services/software-maintenance" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-laptop-code service-icon"></i>
                  <div class="service-info">
                    <h5>Software Maintenance</h5>
                  </div>
                </a>
              </div>
              <!-- Column 3: Financial Services -->
              <div class="mega-col">
                <h4>FINANCIAL SERVICES</h4>
                <a routerLink="/services/housing-mortgage-loans" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-sack-dollar service-icon"></i>
                  <div class="service-info">
                    <h5>Mortgage Loan</h5>
                  </div>
                </a>
                <a routerLink="/services/business-loans" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-briefcase service-icon"></i>
                  <div class="service-info">
                    <h5>Business Loans</h5>
                  </div>
                </a>                
                <a routerLink="/services/personal-loan" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-hand-holding-dollar service-icon"></i>
                  <div class="service-info">
                    <h5>Personal Loans</h5>
                  </div>
                </a>                
              </div>
              <div class="mega-col">
                <h4>TRAVEL SERVICES</h4>
                <a routerLink="/services/corporate-group-travel" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-car service-icon"></i>
                  <div class="service-info">
                    <h5>Travel Booking</h5>
                  </div>
                </a>
                <a routerLink="/services/custom-tour-packages" class="service-card" (click)="onServiceLinkClick()">
                  <i class="fa-solid fa-earth-asia service-icon"></i>
                  <div class="service-info">
                    <h5>Custom Tour Packages</h5>
                  </div>
                </a>
               <a routerLink="/services/flight-train-bus-car-booking" class="service-card" (click)="onServiceLinkClick()">
                  <!-- <i class="fa-solid fa-shield-alt service-icon"></i> -->
                  <i class="fa-solid fa-plane-departure  service-icon"></i>
                  <div class="service-info">
                    <h5>Ticket Booking</h5>
                  </div>
                </a>              
              </div>
            </div>
            <div class="mega-menu-actions desktop-only">
              <a routerLink="/services" class="view-all-btn" (click)="onServiceLinkClick()">View all services &nbsp; <i class="fa-solid fa-up-right-from-square"></i></a>
            </div>
          </div>
        </li>
        <li>
          <a class="nav-item" [routerLink]="['/gallery']" routerLinkActive="active" (click)="closeMenu()">Gallery</a>
        </li>
        <li>
          <a class="nav-item" [routerLink]="['/about']" routerLinkActive="active" (click)="closeMenu()">About Us</a>
        </li>
        <li>
          <a class="nav-item" [routerLink]="['/contact']" routerLinkActive="active" (click)="closeMenu()">Contact</a>

          <!-- <button class="nav-item" type="button" (click)="openContactModal($event)">Contact</button> -->
        </li>
        <li *ngIf="isAdminRoute" class="admin-link">
          <a class="nav-item" routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">Dashboard</a>
        </li>
      </ul>

      <!-- Bottom Consultation CTA Drawer Layout (Mobile Screen Only) -->
      <div class="drawer-footer">
        <button class="nav-cta" type="button" (click)="openContactModal($event)">
          <i class="fa-solid fa-star gold-star"></i> BOOK CONSULTATION
        </button>
        <p class="locations-text">All Over TamilNadu</p>
      </div>

    </nav>
  </div>

  <app-contact-modal *ngIf="showContactModal" (close)="closeContactModal()"></app-contact-modal>
</header>